import type { RouteLocation, RouteLocationRaw } from 'vue-router';

export function redirectToClientPath(to: RouteLocation): RouteLocationRaw {
  return {
    path: `/client${to.path === '/' ? '' : to.path}`,
    query: to.query,
    hash: to.hash,
  };
}
